import styled from 'styled-components';

export const HeaderContainer = styled.header`
  background: rgba(250, 246, 240, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(192, 120, 72, 0.12);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
`;

export const HeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  flex-shrink: 0;
`;

export const LogoMark = styled.div`
  flex-shrink: 0;
`;

export const LogoTitle = styled.span`
  font-family: 'Cormorant Garamond', serif;
  font-size: 20px;
  font-weight: 700;
  color: #1E1208;
  letter-spacing: -0.01em;
  cursor: pointer;
`;

export const NavigationSection = styled.nav`
  display: flex;
  gap: 4px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const NavItem = styled.button<{ $isActive: boolean }>`
  background: ${(p) => (p.$isActive ? 'rgba(192,120,72,0.08)' : 'none')};
  color: ${(p) => (p.$isActive ? '#C07848' : '#5A3820')};
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  font-size: 15px;
  font-weight: ${(p) => (p.$isActive ? '600' : '400')};
  transition: all 0.15s;

  &:hover {
    background: rgba(192, 120, 72, 0.08);
    color: #C07848;
  }
`;

export const AuthSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const AuthButton = styled.button`
  background: #C07848;
  color: white;
  border: none;
  padding: 9px 20px;
  border-radius: 100px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.88;
  }
`;

export const ListSpaceButton = styled.button`
  background: none;
  color: #5A3820;
  border: 1.5px solid rgba(192, 120, 72, 0.3);
  padding: 8px 18px;
  border-radius: 100px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.15s;

  &:hover {
    border-color: #C07848;
    color: #C07848;
  }
`;

/* Legacy — kept for Drawer backwards compat */
export const MobileMenu = styled.div``;
export const MobileNavItem = styled.button``;
export const UlWrapper = styled.ul``;
export const LogoWrapper = styled.div``;
export const SloganWrapper = styled.div``;
export const HeaderWrapper = styled.div``;
export const TitleWrapper = styled.div``;
export const TitleWrappers = styled.div``;
export const MobileMenuButton = styled.button``;
export const Slogan = styled.p``;
